module.exports = __webpack_public_path__ + "static/media/INDEPENDENT.36167310.svg";